import React from 'react'

export default function ModalFeedback({
  messageModal,
  confirmModal,
  onCloseMessage,
  onConfirm,
  onCancel
}) {
  return (
    <>
      {messageModal.open && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60] p-4"
          onClick={onCloseMessage}
        >
          <div className="modal-panel-standard bg-white max-w-md" onClick={(e) => e.stopPropagation()}>
            <div className="mb-3 flex items-start justify-between gap-3">
              <h3 className="text-lg font-semibold text-gray-800">{messageModal.title}</h3>
              <button
                type="button"
                onClick={onCloseMessage}
                className="modal-close-button"
                aria-label="Close modal"
              >
                ×
              </button>
            </div>
            <p className="text-gray-700 whitespace-pre-line">{messageModal.message}</p>
            <div className="mt-5 flex justify-end">
              <button
                onClick={onCloseMessage}
                className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-lg"
              >
                OK
              </button>
            </div>
          </div>
        </div>
      )}

      {confirmModal.open && (
        <div
          className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[60] p-4"
          onClick={onCancel}
        >
          <div className="modal-panel-standard bg-white max-w-md" onClick={(e) => e.stopPropagation()}>
            <div className="mb-3 flex items-start justify-between gap-3">
              <h3 className="text-lg font-semibold text-gray-800">{confirmModal.title}</h3>
              <button
                type="button"
                onClick={onCancel}
                className="modal-close-button"
                aria-label="Close modal"
              >
                ×
              </button>
            </div>
            <p className="text-gray-700 whitespace-pre-line">{confirmModal.message}</p>
            <div className="mt-5 flex justify-end gap-3">
              <button
                onClick={onCancel}
                className="px-4 py-2 bg-gray-300 hover:bg-gray-400 text-gray-800 rounded-lg"
              >
                Cancel
              </button>
              <button
                onClick={onConfirm}
                className="px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}
